/**
 * Process-wide count of saves currently in flight. Background refreshes consult it so a poll that lands
 * mid-save can never overwrite an optimistic edit with older server data.
 */
let writes = 0;

export const beginWrite = (): void => void writes++;
export const endWrite = (): void => void (writes = Math.max(0, writes - 1));
export const writesInFlight = (): number => writes;
